import React from 'react';
type PhoneFrameProps = {
  children: React.ReactNode;
  className?: string;
  label?: string;
};
export function PhoneFrame({
  children,
  className = '',
  label
}: PhoneFrameProps) {
  return <div className={className} data-id="element-28" data-mp="1xufpyn86wgz0">
      <div className="relative mx-auto w-full max-w-[150px] rounded-[1.5rem] border border-white/15 bg-[#02241e] p-1.5 shadow-[0_18px_44px_-22px_rgba(0,0,0,0.9)]" data-id="element-29" data-mp="1xte5js5aai4m">
        <div className="relative aspect-[9/17] overflow-hidden rounded-[1.15rem] bg-[#01332b]" data-id="element-30" data-mp="27k915n4f6u2q">
          <div className="absolute left-1/2 top-1.5 z-10 h-1 w-9 -translate-x-1/2 rounded-full bg-white/20" data-id="element-31" data-mp="2blauxofkidxb" />
          {children}
        </div>
      </div>
      {label ? <p className="mt-3 text-center font-body text-[10px] uppercase tracking-[0.2em] text-secondary/60" data-id="element-32" data-mp="2giuk3jdt0b41">
          {label}
        </p> : null}
    </div>;
}